import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from './../app-routing.module';



import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { SidenavComponent } from './sidenav/sidenav.component';
import { HeaderComponent } from './header/header.component';
@NgModule({
  declarations: [
SidenavComponent,
      HeaderComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    MatIconModule,
    AppRoutingModule,
    NgxSpinnerModule
  ],
  exports: [
    SidenavComponent,
    HeaderComponent,



  ]
})
export class SharedModule { }
